import { useGetWithRefetch } from '../../../hooks/useFetchEndPoint';
import { FullProgram, StudyGroup } from './api/types';

export const useGetStudyGroupProgram = (studyGroup: StudyGroup | null) => {
  return useGetWithRefetch<FullProgram>(
    `/api/v1/syllabus/programs/${studyGroup?.license.program.pk}/?study_group=${studyGroup?.pk}`,
    { running: !!studyGroup },
  );
};

export const useGetStudyGroupProgramByProgramIdAndStudyGroupId = (
  studyGroupId?: string,
  programId?: string,
) => {
  return useGetWithRefetch<FullProgram>(
    `/api/v1/syllabus/programs/${programId}/?study_group=${studyGroupId}`,
    { running: !!(programId && studyGroupId) },
  );
};
